import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import Home from "./pages/Home";
import ServiciosPage from "./pages/ServiciosPage";
import TarifasPage from "./pages/TarifasPage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import { AdminAPI } from "./api/api";
import BlogDetailPage from "./pages/BlogDetailPage";
import LegalPrivacy from "./pages/LegalPrivacy";
import LegalCookies from "./pages/LegalCookies";
import LegalAviso from "./pages/LegalAviso";
import CookieBanner from "./components/CookieBanner";

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [hash, pathname]);

  return null;
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await AdminAPI.me();
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  if (loading)
    return (
      <div style={{ textAlign: "center", marginTop: "4rem" }}>Cargando...</div>
    );

  return (
    <Router>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/tarifas" element={<TarifasPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route
          path="/login"
          element={user ? <Navigate to="/admin" replace /> : <Login />}
        />
        <Route
          path="/admin"
          element={user ? <Admin /> : <Navigate to="/login" replace />}
        />
        <Route path="/privacidad" element={<LegalPrivacy />} />
        <Route path="/cookies" element={<LegalCookies />} />
        <Route path="/aviso-legal" element={<LegalAviso />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieBanner />
    </Router>
  );
}

export default App;
